<template>
    <div v-if="showNewVersion" class="fiscal-statistics-header">
        <dl
            class="fiscal-statistics-header__set fiscal-statistics-header__turnover"
            v-if="permissions.invoicing_access"
        >
            <dt class="fiscal-statistics-header__key typographies-paragraph-small-bold">
                {{ $l10n.__("Chiffre d'affaires total") }}
            </dt>
            <dd class="fiscal-statistics-header__value typographies-paragraph-x-large-bold">
                <template v-if="fiscal">
                    {{ $filters.numberFormat(fiscal.value) }}
                    {{ fiscal.unit ? fiscal.unit : '' }}
                </template>
                <template v-else>
                    {{ $l10n.__('Calcul en cours') }}
                </template>
            </dd>
        </dl>
        <dl
            class="fiscal-statistics-header__set fiscal-statistics-header__late-payments"
            v-if="latePayment && latePayment.value > 0"
        >
            <dt class="fiscal-statistics-header__key typographies-paragraph-small-bold">
                {{ $l10n.__('Règlements en retard') }}
            </dt>
            <dd class="fiscal-statistics-header__value typographies-paragraph-x-large-bold">
                {{ $filters.numberFormat(latePayment.value) }}
                {{ latePayment.unit ? latePayment.unit : '' }}
            </dd>
        </dl>
    </div>
    <div v-else>
        <div class="mb-2" v-if="permissions.invoicing_access">
            <span class="grey fs-3 semibold">{{ $l10n.__("Chiffre d'affaires total") }} : </span>
            <span v-if="fiscal" class="fs-5 bold"
                >{{ $filters.numberFormat(fiscal.value) }}
                {{ fiscal.unit ? fiscal.unit : '' }}</span
            >
            <span v-else class="fs-3 bold">{{ $l10n.__('Calcul en cours') }}</span>
        </div>
        <div class="fs-3 red semibold" v-if="latePayment && latePayment.value > 0">
            <span>{{ $l10n.__('Règlements en retard') }} : </span>
            <span
                >{{ $filters.numberFormat(latePayment.value) }}
                {{ latePayment.unit ? latePayment.unit : '' }}</span
            >
        </div>
    </div>
</template>

<script>
import { dateInterval } from 'js/vue/helpers';
import { mapGetters } from 'vuex';
import Feature from 'Services/Feature';

export default {
    props: {
        linkedtype: {
            type: String,
            required: true,
        },
        linkedid: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            loading: true,
            response: [],
            currency: '1',
        };
    },
    computed: {
        ...mapGetters({
            currencies: 'currencies',
        }),
        fiscal() {
            return this.response.length > 0
                ? this.response
                      .find((cart) => cart.name == 'turnover_third')
                      ?.slots.find((slot) => slot.name == 'total').slots[0]
                : false;
        },
        latePayment() {
            return this.response.length > 0
                ? this.response
                      .find((cart) => cart.name == 'invoice_third')
                      ?.slots.find((slot) => slot.name == 'late')
                      ?.slots.find((subSlot) => subSlot.type == 'amount')
                : false;
        },
        permissions() {
            return this.$store.getters.permissions;
        },
        showNewVersion() {
            return Feature.isEnabled('overview-info-sidebar');
        },
    },
    created() {
        if (localStorage.getItem(`ov_stat_${this.linkedtype}_${this.linkedid}_currency`) !== null) {
            this.currency = localStorage.getItem(
                `ov_stat_${this.linkedtype}_${this.linkedid}_currency`,
            );
        } else {
            if (this.currencies.length >= 1) {
                this.currency = this.currencies[0].id;
            }
        }
        this.fetchStatistics();
    },
    methods: {
        fetchStatistics() {
            const interval = dateInterval('all', moment());

            const filters = {
                datestart: interval.start,
                dateend: interval.end,
                cards: [
                    'invoice_third',
                    'estimate_third',
                    'turnover_third',
                    'top_selling_items_third',
                    'sales_margin_third',
                ],
                currency: this.currency,
            };

            const routeStat = this.$router.resolve({
                name: 'overview.statistics',
                params: { linkedtype: this.linkedtype, linkedid: this.linkedid },
            });

            this.$ajax.get(
                routeStat.href,
                filters,
                (response) => {
                    this.response = response;
                    this.loading = false;
                },
                () => {
                    Push.error(
                        this.$l10n.__(
                            'Une erreur est survenue lors de la récupération des statistiques.',
                            false,
                        ),
                    );
                },
            );
        },
    },
};
</script>
<style lang="scss" scoped>
.fiscal-statistics-header {
    color: var(--colors-common-text-standard-default);
    display: flex;
    flex-direction: row-reverse;
    gap: var(--spacing-3);

    &__set {
        margin: 0;
    }

    &__key {
        margin: 0 0 var(--spacing-0);
    }

    &__value {
        margin: 0;
    }

    &__late-payments {
        .fiscal-statistics-header__value {
            color: var(--colors-common-text-alert-default);
        }
    }
}
</style>
